import { createSlice } from '@reduxjs/toolkit'

export const iaamSlice = createSlice({
    name: 'iaamContext',
    initialState: {
        iaam: {},
        profile: {},
        isAuthenticated: false,
        isUserApproved: null,
    },
    reducers: {
        setIAAM: (state, action) => {
            state.iaam = action.payload;
        },
        setProfile: (state, action) => {
            state.profile = action.payload;
        },
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload;
        },
        setIsUserApproved: (state, action) => {
            state.isUserApproved = action.payload;
        },
    },
})

export const { setIAAM, setProfile, setIsAuthenticated, setIsUserApproved } = iaamSlice.actions;

export const getIAAM = (state) => state.iaamContext.iaam;
export const getProfile = (state) => state.iaamContext.profile;
export const getAuthenticationState = (state) => state.iaamContext.isAuthenticated;
export const getUserApprovalState = (state) => state.iaamContext.isUserApproved;

export default iaamSlice.reducer